export const AVATAR_COLORS = [
	'var(--avatar-purple, #5035C1)',
	'var(--avatar-magenta, #C026D3)',
	'var(--avatar-pink, #DB2777)',
	'var(--avatar-blue, #2563EB)',
	'var(--avatar-teal, #0F766E)',
	'var(--avatar-green, #059669)',
	'var(--avatar-amber, #D97706)',
	'var(--avatar-orange, #EA580C)',
	'var(--avatar-red, #BE123C)',
	'var(--avatar-slate, #334155)',
];

export const getAvatarColorIndex = (seed?: number | string | null): number => {
	if (seed === null || seed === undefined || seed === '') return 0;

	if (typeof seed === 'number' && Number.isInteger(seed)) {
		return Math.abs(seed) % AVATAR_COLORS.length;
	}

	const strSeed = String(seed).trim();
	const num = Number(strSeed);
	if (!Number.isNaN(num) && Number.isInteger(num)) {
		return Math.abs(num) % AVATAR_COLORS.length;
	}

	// Hash string (initials / name) without bitwise / ++ operators for ESLint compliance
	let hash = 0;
	for (let i = 0; i < strSeed.length; i += 1) {
		hash = (hash * 31 + strSeed.charCodeAt(i)) % 2147483647;
	}
	return Math.abs(hash) % AVATAR_COLORS.length;
};

export const getAvatarColor = (seed?: number | string | null): string => {
	const index = getAvatarColorIndex(seed);
	return AVATAR_COLORS[index];
};
